import { calculateAgeByDate } from 'helpers/date';

export type BirthDateParts = {
	dayOfBirth?: string;
	monthOfBirth?: string;
	yearOfBirth?: string;
};

export type BirthDateCheck =
	| { status: 'incomplete' }
	| { status: 'invalid' }
	| { status: 'under-age'; age: number }
	| { status: 'ok'; age: number };

/**
 * Validates the three birth-date selects as one value.
 *
 * Replaces `underMinAgeHandler`, which was written out three times across the
 * register-style forms with slightly different message keys and, being
 * re-created every render, could never be listed in an effect's dependencies.
 */
export const checkBirthDate = (
	{ dayOfBirth, monthOfBirth, yearOfBirth }: BirthDateParts,
	minimumAge?: number
): BirthDateCheck => {
	if (!dayOfBirth || !monthOfBirth || !yearOfBirth) {
		return { status: 'incomplete' };
	}

	const year = Number(yearOfBirth);
	const month = Number(monthOfBirth);
	const day = Number(dayOfBirth);
	const birthDate = new Date(year, month - 1, day);

	// Guards both unparseable input and rolled-over dates such as 31 February.
	if (
		isNaN(birthDate.getTime()) ||
		birthDate.getFullYear() !== year ||
		birthDate.getMonth() !== month - 1 ||
		birthDate.getDate() !== day
	) {
		return { status: 'invalid' };
	}

	const age = calculateAgeByDate(birthDate);

	if (minimumAge !== undefined && age < minimumAge) {
		return { status: 'under-age', age };
	}

	return { status: 'ok', age };
};
